import React, { useState } from 'react';
import { Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import Pagination from "components/ui/pagination/Pagination";

export default function CostAdjustmentDataTable({data}) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    // const navigatefunction = (id) => {
    //   navigate(`${id}`);
    // };
/* --------------------------------------------- Start Pagination  -----------------------------------------------*/
      const recordsPerPage = 10;
      const [currentPageActive, setCurrentPageActive] = useState(1);
      const prePage = (currentPage, setCurrentPage) => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const nextPage = (currentPage, setCurrentPage, npage) => {
        if (currentPage < npage) {
          setCurrentPage(currentPage + 1);
        }
      };
    
      const calculateRecords = (data, currentPage, recordsPerPage) => {
        const firstIndex = (currentPage - 1) * recordsPerPage;
        const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
        return data?.slice(firstIndex, lastIndex);
      };
    
    // Calculate records for activeDiscounts
    const costAdjustmentData = calculateRecords(
        data,
        currentPageActive,
        recordsPerPage
      );
 /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return <>
    <>
    <Table>
        <Thead>
                <Tr>
                    <Th>{t("pages.cost_adjustment.reference")}</Th>
                    <Th>{t("pages.cost_adjustment.branch")}</Th>
                    <Th>{t("pages.cost_adjustment.status")}</Th>
                    <Th>{t("pages.cost_adjustment.business_date")}</Th>
                    <Th>{t("pages.cost_adjustment.created")}</Th>
                </Tr>
        </Thead>
        <Tbody>
            {
            costAdjustmentData?.map((item, index) => (
                <Tr key={index} onClick={()=>navigate(`${item.CostAdjustmentId}`)} >  
                    <Td>{item.CostAdjustmentRef}</Td>
                    <Td>{item.BranchName}</Td>
                    <Td> {item?.CostAdjustmentStatus}  </Td>
                    <Td> {item.BusinessDate} </Td>
                    <Td> {item.created} </Td>
                </Tr>
            ))
            }
        </Tbody>
    </Table>
    <Pagination
            currentPage={currentPageActive}
            setCurrentPage={setCurrentPageActive}
            npage={Math.ceil(data?.length / recordsPerPage)}
            prePage={() => prePage(currentPageActive, setCurrentPageActive)}
            nextPage={() =>
              nextPage(
                currentPageActive,
                setCurrentPageActive,
                Math.ceil(data?.length / recordsPerPage)
                )
              }
        />
    </>

  </>
};
